<template>
  <div class="docIndex" v-loading="loading">
    <NewHeader></NewHeader>
    <!-- 标题 -->
    <div class="institution-title">
      <!-- <img :src="insTitleImg" alt /> -->
      <HeadTitle></HeadTitle>
    </div>
    <!-- 导航 -->
    <div class="navigation">
      <span class="color-blue" @click="$router.push({path:'/'})">首页</span>&nbsp;/&nbsp;
      <span
        class="cur-pointer color-blue"
        @click="toHosDetail(expertData.HOSPITAL_ID)"
      >{{expertData.HOS_NAME}}</span>
      &nbsp;/&nbsp;{{ expertData.DEPT_NAME }}&nbsp;/
      <!-- /&nbsp;<span class="color-blue" @click="$router.push({path:'/hosIndex',query:{id:expertData.OrganizationUID}})">{{expertData.OrganizationName}}</span>&nbsp; -->
      &nbsp;{{expertData.DOC_NAME}}
    </div>
    <div class="doc-head">
      <img :src="expertData.DOC_PHOTO" @error="docNoError(expertData,'DOC_PHOTO')" />
      <div class="doc-msg">
        <div>
          <span>{{expertData.DOC_NAME}}</span>
          <span>{{expertData.DOC_TITLE}}</span>
        </div>
        <div>{{expertData.OrganizationName}}</div>
        <div class="detail-item">
          <span>简介：</span>
          <span v-html="expertData.DOC_RESUME" class></span>
        </div>
        <div class="detail-item">
          <span>擅长：</span>
          <span v-html="expertData.DOC_SKILL"></span>
        </div>
      </div>
      <div class="doc-right">
        <div>
          <div class="item-wrap">
            <div>
              <img src="../assets/img/hosIndex/qianyue.png" alt />
            </div>
            <div>已签约医院</div>
            <div>{{expertData.signCount}}</div>
          </div>
        </div>
        <div>
          <div class="item-wrap">
            <div>
              <img src="../assets/img/hosIndex/huizhen.png" alt />
            </div>
            <div>会诊总数</div>
            <div>{{expertData.diagCount}}</div>
          </div>
        </div>
        <span class="clear"></span>
        <div>
          <div class="item-wrap">
            <div>
              <img src="../assets/img/hosIndex/chaoshi.png" alt />
            </div>
            <div>超时数</div>
            <div>{{expertData.overtimeCount}}</div>
          </div>
        </div>
        <div>
          <div class="item-wrap">
            <div>
              <img src="../assets/img/hosIndex/huitui.png" alt />
            </div>
            <div>回退数</div>
            <div>{{expertData.backCount}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="hos-list">
      <div
        v-for="organList in organList"
        class="cur-pointer"
        @click="toHosDetail(organList.HOSPITAL_ID)"
      >
        <div class="hos-top">
          <img
            class="cur-pointer"
            :src="organList.HOS_PHOTO"
            @error="hosNoError(organList,'hos_photo')"
            @click="toHosDetail(organList.HOSPITAL_ID)"
          />
          <!-- $router.push({path:'/hosIndex',query:{id:organList.OrganizationUID}}) -->
          <div>
            <div>{{organList.HOS_NAME}}</div>
            <div>已签约{{organList.signExpCount}}人</div>
            <div>申请诊断数：{{organList.applyForDiagCount}} 人次</div>
            <div>回退申请数：{{organList.backCount}} 人次</div>
          </div>
        </div>
        <div class="hos-bottom">
          <div>
            <div>类型</div>
            <div>CT</div>
            <div>DR</div>
            <div>DX</div>
            <div>MR</div>
          </div>
          <div>
            <div>人次</div>
            <div>{{organList.CTCount || 0}}</div>
            <div>{{organList.DRCount || 0}}</div>
            <div>{{organList.DXCount || 0}}</div>
            <div>{{organList.MRCount || 0}}</div>
          </div>
        </div>
      </div>
      <div></div>
    </div>
    <div class="clear-both"></div>
    <NewFooter></NewFooter>
  </div>
</template>
<script>
// @ is an alias to /src
import doc from '../assets/img/index/doc1.png'
import hosNo from '../assets/img/index/lunbo.png'

import NewHeader from '../components/NewHeader.vue'
import HeadTitle from '../components/HeadTitle.vue'
import NewFooter from '../components/NewFooter.vue'
export default {
  name: 'docIndex',
  data() {
    return {
      insTitleImg: require('../assets/img/regInstitution/hengfeng_title.png'),
      loading: true,
      expertData: {},
      organList: [],
      hosName: ''
    }
  },
  watch: {
    $route: function(to, from) {
      //执行数据更新查询
      this.getDoc()
    }
  },
  components: {
    NewHeader,
    HeadTitle,
    NewFooter
  },
  methods: {
    docNoError(d, name) {
      //图片error处理
      d[name] = doc
    },
    hosNoError(d, name) {
      //图片error处理
      d[name] = hosNo
    },

    // 跳转医院详情：
    toHosDetail(id) {
      this.$router.push({
        path: '/hosIndex',
        query: { organ_id: id }
      })
    },

    getDoc() {
      let that = this
      this.loading = true
      var params = new URLSearchParams()
      params.append('expert_id', that.$route.query.id)
      this.$ajax
        .post('homePage/expertHomePage', params)
        .then(response => {
          this.loading = false
          if (response.msg) {
            that.expertData = response.expertData
            that.organList = response.hosList
            console.log('签约医院', that.organList)
          }
        })
        .catch(error => {
          this.loading = false
        })
    },
    toHos(id) {
      this.$router.push({ path: '/hosIndex', query: { id: id } })
    }
  },
  created() {
    this.getDoc()
  },

  mounted() {}
}
</script>
<style  lang="stylus">
.docIndex {
  .institution-title {
    margin-top: 100px;
    text-align: center;
    img {
      height: 75px;
    }
  }
  .navigation {
    font-size: 16px;
    width: 1200px;
    margin: 50px auto 0px auto;
    border-bottom: 2px solid #E1E1E1;
    padding-bottom: 20px;
    span {
      cursor: pointer;
    }
  }
  .doc-head {
    width: 1200px;
    min-height: 230px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 8px rgba(208, 232, 242, 1);
    opacity: 1;
    border-radius: 8px;
    margin: 30px auto;
    display: flex;
    >img {
      width: 140px;
      height: 140px;
      border-radius: 50%;
      margin: 45px 36px 45px;
    }
    .doc-msg {
      width: 643px;
      margin: 45px 0px;
      >div {
        &:first-child {
          margin-top: 5px;
          span {
            &:first-child {
              font-size: 18px;
              color: #0080CB;
              margin-right: 20px;
            }
            &:nth-child(2) {
              font-size: 16px;
              color: #333;
            }
          }
        }
        &:nth-child(2) {
          margin-top: 8px;
          font-size: 14px;
          color: #0080CB;
        }
        &.detail-item {
          display: flex;
          margin-top: 13px;
          font-size: 12px;
          color: #999;
          span {
            &:first-child {
              white-space: nowrap;
            }
            &:nth-child(2) {
              color: #333;
              padding: 0 40px 0 0;
            }
          }
          p {
            color: #333;
          }
        }
      }
    }
    .doc-right {
      width: 344px;
      border-left: 1px solid #eee;
      overflow: hidden;
      >div {
        text-align: center;
        float: left;
        min-height: 50%;
        width: 170px;
        border: 1px solid rgba(239, 245, 248, 1);
        font-size: 14px;
        cursor: pointer;
        display: flex;
        // flex-direction row
        justify-content: center;
        align-items: center;
        >.item-wrap {
          >div {
            width: 100%;
            margin-bottom: 3px;
          }
          img {
            width: 30px;
            height: 30px;
            margin-top: 10px;
          }
          &:nth-child(1) {
            color: #41CB8C;
          }
          &:nth-child(2) {
            color: #43A4DF;
          }
          &:nth-child(3) {
            color: #FE6670;
          }
          &:nth-child(4) {
            color: #7795E6;
          }
        }
      }
    }
  }
  .hos-list {
    width: 1153px;
    margin: 0 auto 80px auto;
    background: rgba(241, 245, 249, 1);
    padding: 15px 5px;
    >div {
      cursor: pointer;
      margin: 4px;
      width: calc(33.3333% - 8px);
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 4px rgba(208, 232, 242, 1);
      float: left;
      &:last-child {
        float: none;
        clear: both;
      }
      .hos-top {
        display: flex;
        color: #666;
        font-size: 14px;
        img {
          width: 150px;
          height: 100px;
          margin: 15px 10px;
        }
        >div {
          padding: 4px;
          >div {
            margin-bottom: 7px;
            &:first-child {
              margin-bottom: 10px;
              margin-top: 15px;
              font-size: 16px;
              color: #0080CB;
            }
          }
        }
      }
      .hos-bottom {
        padding: 10px 15px;
        border-top: 2px solid #DDEEF6;
        >div {
          display: flex;
          margin: 15px;
          >div {
            text-align: center;
            font-size: 16px;
            color: #333;
            width: 83px;
            &:not(:first-child) {
              padding-top: 3px;
            }
          }
        }
      }
    }
  }
}
</style>
